import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "./EntityCommand";
import { EntityCommandInformation, IEntityCommandInformation } from "./EntityCommandInformation";
import { MethodEvaluator } from "./Evaluation/MethodEvaluator";
import { PartialNullable } from "./Extensions";
import { NAMESPACE } from "./_Namespace";
import { Property } from "./RadObject";
import { WindowShim } from "./RadWindow";
import { PermissionEvaluator } from "./Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";

const
    radWindow = WindowShim();

(radWindow as any).EntityCommandShowSoftDeleted = {
    showSoftDeletedVisibilityEvaluatorMethod: function (methodEvaluator: MethodEvaluator): boolean
    {
        const
            entityCommandInformation = methodEvaluator.state.get() as IEntityCommandInformation;

        if (!entityCommandInformation)
            return false;

        const
            caller = entityCommandInformation.caller.get();

        if (!caller || !caller.applicationEntitySupportsSoftDelete)
            return false;

        return !!caller.applicationEntitySupportsSoftDelete.get();
    },
};

export type EntityCommandShowSoftDeletedPropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandShowSoftDeletedProperties = {
    [name in keyof EntityCommandShowSoftDeletedPropertyValues]: Property<EntityCommandShowSoftDeletedPropertyValues[name]>
};

export interface IEntityCommandShowSoftDeleted extends IEntityCommand, EntityCommandShowSoftDeletedProperties
{
}

export class EntityCommandShowSoftDeleted extends EntityCommand<EntityCommandShowSoftDeletedPropertyValues> implements IEntityCommandShowSoftDeleted
{
    public static override classNamespace = NAMESPACE + "EntityCommandShowSoftDeleted";
    public static override className = "EntityCommandShowSoftDeleted";

    // #region Static

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandShowSoftDeletedPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Show Soft Deleted",
                isToggle: true,
                key: "SHOW_SOFT_DELETED",
                permission: PermissionEvaluator.permissionLevels.read,
                type: EntityCommandTypeEnum.entitySet,
                visibleEvaluator: new MethodEvaluator({
                    methodPath: "EntityCommandShowSoftDeleted.showSoftDeletedVisibilityEvaluatorMethod",
                }),
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        caller = entityCommandInformation.caller.get();

                    if (!caller || !caller.includeSoftDeleted?.set)
                        return;

                    caller.includeSoftDeleted.set(value);
                })
        );
    }

    // #endregion

    // #endregion
}

